import { State } from 'types';
import { HomepagePreview } from '../types';
import { createSelector } from 'reselect';

import { FeedPost } from 'types/models';

import { getPreview } from 'config';
import moment from 'moment';

const spb = (state: State) => state.homepage.spb;

export const spbSelector = createSelector([spb], data => {
  const arraySelector: (HomepagePreview & { exclusive_material: boolean })[] =
    [];

  if (data && data.length) {
    data.map((item: FeedPost, _index: number) => {
      if (item) {
        let dateArticle = item.created_at;
        if (item.publication_at) {
          dateArticle = item.publication_at;
        }

        const object = {
          id: item.id,
          link: item.categories_path + '/' + item.slug,
          img: getPreview(
            item.get_post_types,
            item.announce_img,
            null,
            true,
            moment(dateArticle)
          ),
          date: moment(dateArticle).format('DD.MM.YYYY'),
          title: item.title,
          exclusive_material: item.exclusive_material,
        };

        arraySelector.push(object);
      }
    });
  }

  return arraySelector;
});
